// extracted by mini-css-extract-plugin
export default {"cls1":"hPHOmk1ue1Fdnngyllyy","cls2":"zZx2lmtTwaaFtAyY08HD hPHOmk1ue1Fdnngyllyy"};